module.exports = __webpack_public_path__ + "20261103_v3.3.5/img/floating-point-icon.91a48424.png";